var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discount-tag",style:(_vm.style)},[(_vm.iconType)?_c('i',{staticClass:"icon_pay",class:_vm.iconType}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.tag.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }